import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import * as trans from "../common/Translator";
import * as ts from "../common/Translator";
import * as OutputFormat from "../constants/OutputFormat";
import {currentUserSettings} from "../login/LoginPresenter";
import {NamaKendoWindow} from "./NamaKendoWindow";
import {getCustomGUISettings} from "../login/ClientCache";

export class ReportLauncherView {
    /**
     *
     * @param {ReportLauncherPresenter} presenter
     */
    constructor(presenter) {
        this.presenter = presenter;
    }

    render() {
        let that = this;
        let reportTitle = trans.isArabic() ? that.presenter.reportRef.name1 : that.presenter.reportRef.name2;
        that.rootElement = $(`<div>
            <div class="w-100 d-flex justify-content-center h3">${reportTitle}</div>
            </div>`);
        let questionFieldsEditor = new QuestionFieldsEditor(that.entityType);
        that.presenter.metaData = {fieldsMetaData: [...that.presenter.reportMetaData.questionFields.map(qField => qField.metaData)]};
        questionFieldsEditor.edit(that.presenter.reportMetaData.questionFields, that.presenter.defaultParameterValues(), null, null, that.presenter, that, that.presenter);
        that.rootElement.find('.info-body').addClass('border border-light');
        that.presenter.questionFieldsEditor = questionFieldsEditor;
        let actionsContainer = $(`<div class="form-group col-md-6 my-1"><div class=" row align-items-center w-100 m-auto"></div></div>`);
        let runReportBtn = $(`<button class="col-lg-2 px-1 m-1" id="runReport">${ts.translateId("runReport")}</button>`);
        runReportBtn.kendoButton({
            click: (e) => {
                e.event.stopPropagation();
                that.questionFields = questionFieldsEditor.getQuestionFields();
                that.presenter.onClick(true, formatList.data("kendoDropDownList").value())
            }
        });
        let runReportInsideWindowBtn = $(`<button class="col-lg-3 px-1 m-1" id="runReportInsideWindow">${ts.translateId("runReportInsideWindow")}</button>`);
        runReportInsideWindowBtn.kendoButton({
            click: (e) => {
                e.event.stopPropagation();
                that.questionFields = questionFieldsEditor.getQuestionFields();
                that.presenter.onClick(false, formatList.data("kendoDropDownList").value())
            }

        });
        let formatList = $(`<input id = "formatList" class="col-lg-3 px-1 m-1"/>`);
        let reportDetails = $(`<a href="#" id="reportDetails" class="col-lg-1 px-1 k-icon k-i-info m-1"></a>`);
        reportDetails.on("click", ((e) => {
            e.preventDefault();
            e.stopPropagation();
            that.showReportDetails();
        }));
        let container = actionsContainer.find(".row");
        container.append(formatList);
        container.append(runReportBtn);
        container.append(runReportInsideWindowBtn);
        container.append(reportDetails);
        actionsContainer.appendTo(that.rootElement);
        let viewFormat = that.presenter.reportMetaData.viewingFormat || currentUserSettings().viewingFormat || getCustomGUISettings().tooltipsAndReportsAndRevise.globalConfigReportsViewingFormat || OutputFormat.HTML;
        formatList.kendoDropDownList({
            value: viewFormat,
            dataSource: [OutputFormat.HTML, OutputFormat.PDF],
            change: function (e) {
                that.presenter.place.format = this.value() || OutputFormat.HTML;
            }
        });
        that.rootElement.height(that.rootElement.parent().height());
        return that.rootElement;
    }

    addDataWidget(widget) {
    }

    showReportDetails() {
        let that = this;
        let window = new NamaKendoWindow("reportDetails");
        let repDetails = $(`<Label class="w-100 h-100 m-0" id = "repDetails"></Label>`);
        window.width = "50%";
        window.relatedPresenter = that.presenter;
        let reportDetails = that.presenter.reportMetaData.reportDetails;
        if (!reportDetails) {
            reportDetails = ts.translateId("noReportDetails");
            repDetails.addClass('text-center');
        }
        repDetails.text(reportDetails);
        window.addDataWidget(repDetails);
        window.showWindow();
    }
}